// Auto-generated file - do not edit manually
// Run 'node scripts/generateMediaList.js' to update

const mediaFiles = [
  {
    "src": "/images/pastImages/20221117_093823~2.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/20221117_094019~2.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/75366358804__D2BA3951-2A9E-4F79-8C6A-99B11347A7B8.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_0618.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_0619.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_0620.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_0625.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_0626.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_0640.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_0672.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_0674.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_0675.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_0676.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1045.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1204.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1207.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1209.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1212.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1216.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1506.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1586.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_1586.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1614.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_1614.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1619.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_1619.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1630.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_1630.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1642.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_1642.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1651(1).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1651.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_1651.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1655.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1657.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1660.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1663.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1665.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_1665.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1677.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1685.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1686.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_1686.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1692.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_1692.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1694.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1706.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1816.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1817.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1820.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1823.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1888.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1945.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1957.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1959.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1960.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1961.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1962.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1965.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1966.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1967.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_1971.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_20230429_132321_431.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_20230429_133154_195.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2058.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2074.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2075.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2097.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2102.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2106.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2107.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2110.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2114.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2116.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2119.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2120.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2133.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2158(1).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2158.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2159.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2179.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2191.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2195.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2196.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2245.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2261.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2268.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2271.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2274.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2275.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2278.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2281.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2283.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2425 Copy.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2431.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2432.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2443.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2446.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2448.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2453.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2456.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2460.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2463.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2465.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2469.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2470.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2472.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2474.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2488.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2489.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2494.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2495.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2505.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2542.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2553.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2554.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2557.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2559.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2560.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2563.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2565.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2567.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2568.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2615.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2618.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2622.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2647.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2648.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2649.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2651.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2652.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2859.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2879.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_2879.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2915.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_2915.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2917.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2930.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2934.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2940.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2944.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_2944.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2950.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_2950.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2951.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2973.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2977.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2978.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2980.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_2980.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2982.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_2982.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2994.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_2995.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3017.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3064.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3066.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_3066.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3068.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3069.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_3069.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3071.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3131.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3210.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3217.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_3217.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3264.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_3264.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3353.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3356.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3358.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3361.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_3361.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3436.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3541.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3550.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3551.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_3551.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3552.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_3552.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3577.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_3577.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3578.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_3578.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3583.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3619.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_3619.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3620.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3621.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3623.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3626.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3670.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3671.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3673.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3674.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3737.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3738.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3825.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3964.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3966.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3967.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3968.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3969.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3970.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3971.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3972.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3973.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3974.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3975.JPG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_3985.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4004.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4009.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4010.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4011.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4013.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4025.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4029.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4030.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4033.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4034.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4035.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4036.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4037.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4038.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4110.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4111.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4130.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4131.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4133.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4134.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4135.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4136.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4174.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4176.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4177.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4178.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4181.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4182.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4185.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4187.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4188.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4216.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4220.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4237.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_4237.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4299.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4304.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4310.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4311.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_4311.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4319.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4420.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4421.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4425.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4434.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4435(1).PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4435.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4436.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4439.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4440.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4441(1).PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4441.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4442.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4444.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4445.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4546.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4549.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4551.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4553.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4554.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4555.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4557.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4558.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4623.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4625.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4628.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4633.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4655.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4684.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4686.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4689.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4690.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4694.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4696.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4699.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4700.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4701.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4704.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4706.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4711.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4739.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4740.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4741.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4742.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4744.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4748.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4807.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4811.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4813.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4814.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4816.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4818.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4819.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4820.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4821.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4822.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4833.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4845.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4912.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4958.PNG",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_4975.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5003.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5004.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5005.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5006.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5009.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5010.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5011.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5012.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5014.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5080.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5137.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_5255.MP4",
    "type": "video"
  },
  {
    "src": "/images/pastImages/IMG_5255.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5436.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5437.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_5449.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_6310.jpeg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/IMG_8558.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/Resized_tempFileForShare_20240701-110135_379019382642600.jpeg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(1).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(10).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(11).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(12).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(13).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(14).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(15).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(16).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(2).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(3).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(4).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(5).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(6).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(7).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(8).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000(9).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000000.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000001(1).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000001(2).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000001(3).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000001(4).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000001(5).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000001(6).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000001.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000002(1).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000002(2).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000002(3).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000002(4).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000002(5).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000002(6).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000002(7).jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000002.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000003.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000004.jpg",
    "type": "image"
  },
  {
    "src": "/images/pastImages/image000005.jpg",
    "type": "image"
  }
];

export default mediaFiles;
